import React from 'react'

import { AppsView } from './AppsView'
import { useApps } from './hooks/useApps'

export const AppsContainer = () => {
  const { tabs, apps } = useApps()

  return <AppsView tabs={tabs} apps={apps} />
}
